import { Injectable } from '@angular/core'

@Injectable()
export abstract class SalesContactDao {
  abstract create(mail: string): Promise<void>

  abstract findAllLimit7(): Promise<string[]>
}
